import React from 'react'
import { connect } from 'react-redux'

const currentYear = safeSiteData.current_year

class Footer extends React.Component {
	render() {
		return (
			<footer className="footer">
				<div className="-inner">
					<p>
						Copyright &copy; { currentYear } Saving Animals from Euthanasia (SAFE Inc.) | <a href="/wp-content/uploads/SAFE Privacy Policy_rev2_Feb2021.pdf" target="_blank">Privacy Policy</a>
						<br />
						1 Gunsberg Ct, Pegs Creek WA 6714 08 9185 4634
						<br />
						Website by <a href="http://alexgreendesign.com" target="_blank">Alex Green Design</a>
					</p>

					<div className="-country">
						<p>
							SAFE Inc. acknowledges Traditional Owners of Country throughout Australia and recognises the continuing connection to lands, waters and communities. We pay our respect to Aboriginal and Torres Strait Islander cultures; and to Elders past, present and emerging.
						</p>
					</div>
				</div>
			</footer>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Footer )



// WEBPACK FOOTER //
// ./components/footer/footer.jsx